/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import UIFlex from 'UIComponents/layout/UIFlex';
import TX120BaseSurveyModal from './Tx120BaseSurveyModal';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect, useState } from 'react';
import { upgradeProductSurveyResponseMap } from '../../SurveyResponses';
import { handleSubmitSurveyResponses } from '../../../utils/tx120SurveySubmit';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Tx120PricingPageSurveyModal = ({
  apiName,
  setInitialSuccessModal,
  setLoadingModal,
  upgradeData
}) => {
  const [allFeatures, setSelectedFeatures] = useState(upgradeProductSurveyResponseMap[apiName]);
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const isDisabled = Object.values(allFeatures).every(isSelected => !isSelected);
  useEffect(() => {
    tracker.track('trialActivationInteraction', Object.assign({
      action: 'viewed pricing page survey modal'
    }, upgradeData));
  }, [upgradeData]);
  const handleCreateTrialGuide = async () => {
    if (isOtherSelected) {
      tracker.track('trialActivationInteraction', Object.assign({
        action: 'selected other'
      }, upgradeData));
    }
    await handleSubmitSurveyResponses(apiName, allFeatures, upgradeData);
    setLoadingModal();
  };
  const handleSkip = () => {
    tracker.track('trialActivationInteraction', Object.assign({
      action: 'survey skipped'
    }, upgradeData));
    setInitialSuccessModal();
  };
  const renderModalFooter = className => {
    return /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      direction: "column",
      gap: 20,
      className: className,
      children: [/*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.tx0120.pricingPageModal.tooltip"
        }),
        disabled: !isDisabled,
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: handleCreateTrialGuide,
          disabled: isDisabled,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.tx0120.pricingPageModal.createTrialGuideButton"
          })
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "link",
        onClick: handleSkip,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.tx0120.pricingPageModal.skipButton"
        })
      })]
    });
  };
  return /*#__PURE__*/_jsx(TX120BaseSurveyModal, {
    apiName: apiName,
    renderModalFooter: renderModalFooter,
    allFeatures: allFeatures,
    isOtherSelected: isOtherSelected,
    setSelectedFeatures: setSelectedFeatures,
    setIsOtherSelected: setIsOtherSelected
  });
};
export default Tx120PricingPageSurveyModal;